// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"02d74fbd","244":"5357a8fe","300":"55e03187","352":"826ebd8e","394":"05a0d2f9","450":"93a4b731","453":"50d6a532","493":"1ea2f544","531":"7c7f547a","817":"c572c115","874":"7dfbcce8","946":"7bb0f299","970":"b9ad9d50"}[chunkId] + ".chunk.js";
};